import React, { useState, useEffect } from 'react';
import { dateOptions } from '../../../utils/dates';
import { makeValveExercise } from '../../../models';
import { getValveExerciseLatest } from '../../../services/api';
import ExerciseChart from '../../../components/ExerciseChart';

const ValveSummary = ({ valve }) => {
  const [exercise, setExercise] = useState(null);
  const [loadingExercise, setLoadingExercise] = useState(true);
  
  useEffect(() => {
    setupExercise();
  }, [valve]);

  // useEffect(() => {
  //   setLoading(loadingExercise); //was a param
  // }, [loadingExercise]);

  const setupExercise = async () => {
    try {
      setLoadingExercise(true);
      if (valve) {
        const fetchedExercise = await getValveExerciseLatest(valve.id);
        setExercise(makeValveExercise(fetchedExercise));
      }
      setLoadingExercise(false);
    } catch (ex) {
      console.log(ex);
      setLoadingExercise(false);
    }
  };

  return (
    <tr className="page-break">
      <td>
        <div className="record-result">
          <div className="result-details">
            <div className="result-detail">
              <label>Device Type:</label>
              <span>Valve</span>
            </div>
            <div className="result-detail">
              <label>Device ID:</label>
              <span>{valve?.name}</span>
            </div>
          </div>
          {!exercise?.manual &&
          <div className="record-settings">
            <div className="record-setting">
              <label>Set Rev:</label>
              <span>{exercise?.revolutions}</span>
            </div>
            <div className="record-setting">
              <label>Set Torque:</label>
              <span>{exercise?.torqueSetPoint}</span>
            </div>
            <div className="record-setting">
              <label>Set Speed:</label>
              <span>{exercise?.rpmSetPoint}</span>
            </div>
          </div>}
          <div className="record-location">
            <div className="record-location-info">
              <div className="record-location-detail">
                <label>Address:</label>
                <span>{((valve?.streetNumber ?? '') + ' ' + (valve?.streetName ?? '')).trim()}</span>
              </div>
              <div className="record-location-detail">
                <label>Cross Street:</label>
                <span>{valve?.crossStreet}</span>
              </div>
              <div className="record-location-detail">
                <label>Location:</label>
                <span>{valve?.locationNotes}</span>
              </div>
              <div className="record-location-detail">
                <label>District:</label>
                <span>{valve?.district}</span>
              </div>
              <div className="record-location-detail">
                <label>Sub-Division:</label>
                <span>{valve?.subDivision}</span>
              </div>
            </div>
            <div className="record-gps-info">
              <div className="record-gps-detail">
                <label>Latitude:</label>
                <span>{valve?.latitude?.toFixed(6)}</span>
              </div>
              <div className="record-gps-detail">
                <label>Longitude:</label>
                <span>{valve?.longitude?.toFixed(6)}</span>
              </div>
              <div className="record-gps-detail">
                <label>Elevation:</label>
                <span>{valve?.elevation?.toFixed(2)}</span>
              </div>
              <div className="record-gps-detail">
                <label>State X / Y:</label>
                <span>{valve?.stateX} / {valve?.stateY}</span>
              </div>
            </div>
          </div>
          <div className="record-info">
            <div className="record-info-detail">
              <label>Manufacturer:</label>
              <span>{valve?.manufacturer}</span>
            </div>
            <div className="record-info-detail">
              <label>Install Date:</label>
              <span>{valve?.installDate ? new Date(valve.installDate).toLocaleDateString('en-US', dateOptions) : ''}</span>
            </div>
            <div className="record-info-detail">
              <label>Status:</label>
              <span>{valve?.status}</span>
            </div>
            <div className="record-info-detail">
              <label>Valve Size:</label>
              <span>{valve?.size?.toFixed(2)}</span>
            </div>
            <div className="record-info-detail">
              <label>Open Direction:</label>
              <span>{exercise?.openDirection}</span>
            </div>
            <div className="record-info-detail">
              <label>Bury Depth:</label>
              <span>{valve?.boxDepth?.toFixed(2)}</span>
            </div>
          </div>
          <div className="record-stats">
            <div className="record-info-detail">
              <label>Exercise Date:</label>
              <span>{exercise?.exerciseDate ? new Date(exercise.exerciseDate).toLocaleDateString('en-US', dateOptions) : ''}</span>
            </div>
            {exercise?.manual ?
              <>
                <div className="record-stat">
                  <label>Manual Difficulty:</label>
                  <span>{exercise?.difficulty}</span>
                </div>
                <div className="record-stat full-row">
                  <label>Comments:</label>
                  <span>{exercise?.comments}</span>
                </div>
              </>
            : 
              <>
                <div className="record-stat">
                  <label>Total Revs:</label>
                  <span>{valve?.totalRevolutions}</span>
                </div>
                <div className="record-stat">
                  <label>Cycle Count:</label>
                  <span>{valve?.autoCycles}</span>
                </div>
                <div className="record-stat">
                  <label>Max Torque:</label>
                  <span>{valve?.maxTorque}</span>
                </div>
                <div className="record-stat">
                  <label>Revs @ Max Torque:</label>
                  <span>{valve?.maxTorqueRevolutions}</span>
                </div>
                <div className="record-stat">
                  <label>Max Rev In Set Dir:</label>
                  <span>{valve?.maxDirectionRevolutions}</span>
                </div>
                <div className="record-stat full-row">
                  <label>Comments:</label>
                  <span>{exercise?.comments}</span>
                </div>
              </>
            }
          </div>
          {!exercise?.manual && <ExerciseChart exercise={exercise} />}
        </div>
      </td>
    </tr>
  )
};

export default ValveSummary;